import { createContext } from 'react'

/** @type {import('react').Context<null | {
 *   isOpen: boolean,
 *   isExiting: boolean,
 *   isExpanded: boolean,
 *   activeArtifact: import('./documentPreviewTypes.js').GeneratedArtifactPreview | null,
 *   openPreview: (selection: import('./documentPreviewTypes.js').DocumentPreviewSelection) => void,
 *   closePreview: () => void,
 *   expandPreview: () => void,
 *   collapsePreview: () => void,
 * }>} */
export const DocumentPreviewContext = createContext(null)
